import { AIIcon } from '@components/AIIcon'
import { Chip } from '@mui/material'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Badge component that displays "Prefilled by AI" indicator
 */
const CHIP_STYLES = {
	borderColor: 'ai.main',
	color: 'ai.main',
	'& .MuiChip-icon': {
		ml: 1,
	},
} as const

export const AIPrefillBadge = (): JSX.Element => {
	const { t } = useTranslation()

	return (
		<Chip
			icon={<AIIcon />}
			label={t('prefilledByAI')}
			size="small"
			variant="outlined"
			sx={CHIP_STYLES}
		/>
	)
}
